import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import tagsView from './modules/tagsView'
import user from './modules/user'
import permission from './modules/route-permission'
import enmus from './modules/enums'
import print from './modules/print'
import home from './modules/home'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        invoiceTable: { detailId: String, outInvoiceData: [] }
    },
    getters: getters,
    mutations: {
        setInvoiceTableData(state, payload) {
            state.invoiceTable.detailId = payload.detailId
            state.invoiceTable.outInvoiceData = payload.outInvoiceData
        }
    },
    actions: {},
    modules: {
        app,
        tagsView,
        home,
        user,
        permission,
        enmus,
        print
    }
})
